module.exports = __webpack_public_path__ + "img/logo_news24.462bdcb7.png";